import { TariffsProduct } from 'src/components/TariffPlans/types';

export function getProductToNavigate(product: TariffsProduct) {
  switch (product) {
    case 'evolutionMlInferenceInstanceTypeGpu':
    case 'evolutionMlInferenceModelSharedGpu':
      return 'evolutionMlInference';
    default:
      return product;
  }
}
